<div class="main-container">
  <div class="assessment-status success" [ngStyle]="{ 'border-left-color': statusColor }">
    <p class="assessment-status__title" [ngStyle]="{ color: statusColor }" [innerHTML]="safeHtmlMessage || ''"></p>
    <p class="assessment-status__description">
      {{ status?.description }}
      <br />
      @if (isFlu) {
        To self-report a flu vaccine dose,
        <ods-link
          href="https://upmchs.sharepoint.com/sites/MemberportalmodernizationHealthInsuranceteams/Lists/Flu%20SelfAttestation/AllItems.aspx?viewid=1b727f31%2D980c%2D47a3%2Db9f4%2D7c67e3bbb2cc&playlistLayout=playback&itemId=1&OR=Teams%2DHL&CT=1698860053059&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyNy8yMzA5MjkxMTIwNyIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D"
          target="_blank"
          variant="inline">
          follow these step-by-step instructions
        </ods-link>
        .
      }

      @if (!isFlu) {
        To self-attest a COVID vaccine dose,
        <ods-link
          href="https://upmchs.sharepoint.com/sites/MemberportalmodernizationHealthInsuranceteams/Lists/COVID19%20SelfAttestation/AllItems.aspx?viewid=aa500cb5%2D90c4%2D4044%2Daf14%2D5a7ec61b3c11&playlistLayout=playback&itemId=1"
          target="_blank"
          variant="inline">
          follow these step-by-step instructions
        </ods-link>
        .
      }
    </p>
  </div>

  @if (outageMessage) {
    <div class="outage">
      <div class="maintananca-icon"></div>
      <div class="outage-text" [innerHTML]="outageMessage"></div>
    </div>
  }
</div>

<div class="main-container container-fluid">
  @if (info) {
    <div>
      @for (infoItem of info; track infoItem) {
        <article class="flu-shot row">
          <div class="flu-shot__info">
            <h3 class="flu-shot__info__title">{{ infoItem.name }}</h3>
            <div class="flu-shot__info__description">{{ infoItem.description }}</div>
            <div class="flu-shot__info__receipts">
              @for (receipt of infoItem.receipts; track receipt) {
                <ods-button
                  variant="text"
                  [attr.aria-label]="'Print ' + infoItem.name + ' ' + receipt.fluPeriod"
                  (click)="showReceipt(receipt)">
                  <ods-icon variant="printer"></ods-icon>
                  {{ receipt.fluPeriod }}
                </ods-button>
              }
            </div>
          </div>
          @if (isFlu) {
            <div class="action-btn__wrap">
              @switch (infoItem.statusId) {
                @case (1) {
                  <button
                    [disabled]="outageMessage ? 'true' : ''"
                    (click)="showLearnMore(infoItem)"
                    class="action-btn-lg primary new"
                    [attr.aria-label]="infoItem.name + ' Learn More'">
                    <span class="text">Learn more</span>
                    <span class="icon"><i aria-hidden="true"></i></span>
                  </button>
                }
                @case (2) {
                  <button disabled class="action-btn-lg complete">
                    <span class="text">Complete</span>
                    <span class="icon"><ods-icon variant="checkmark" aria-hidden="true"></ods-icon></span>
                  </button>
                }
                @case (4) {
                  <button disabled class="action-btn-lg primary review">
                    <span class="text">Pending</span>
                    <span class="icon"><ods-icon variant="more" aria-hidden="true"></ods-icon></span>
                  </button>
                }
              }
            </div>
          }
        </article>
      }
    </div>
  }

  @if (questionnaires) {
    <div class="questionnaries">
      @for (question of questionnaires; track question) {
        <article class="flu-shot" [class.locked]="question.statusId === 3">
          <div class="flu-shot__info">
            <h3 class="flu-shot__info__title">{{ question.title }}</h3>
            <div class="flu-shot__info__description">{{ question.description }}</div>
            <div class="flu-shot__info__receipts">
              @for (receipt of question.receipts; track receipt) {
                <ods-button
                  variant="text"
                  [attr.aria-label]="'Print ' + question.title + ' ' + receipt.fluPeriod"
                  (click)="showReceipt(receipt, question.id)">
                  <ods-icon variant="printer"></ods-icon>
                  {{ receipt.fluPeriod }}
                </ods-button>
              }
            </div>
          </div>
          <div class="action-btn__wrap">
            @switch (question.statusId) {
              @case (1) {
                <button
                  [disabled]="outageMessage ? 'true' : ''"
                  (click)="showQuestionary(question)"
                  class="action-btn-lg primary new"
                  [attr.aria-label]="question.title + ' Document Now'">
                  <span class="text">Document Now</span>
                  <span class="icon"><i aria-hidden="true"></i></span>
                </button>
              }
              @case (2) {
                <button [class]="question.isTaken ? 'complete' : ['complete', 'disabled']" disabled class="action-btn-lg pull-right">
                  <span class="text">Complete</span>
                  <span class="icon"><ods-icon variant="checkmark" aria-hidden="true"></ods-icon></span>
                </button>
              }
              @case (3) {
                <button class="action-btn-lg denied" disabled>
                  <span class="text">Locked</span>
                  <span class="icon">
                    <ods-icon variant="locked" aria-hidden="true"></ods-icon>
                  </span>
                </button>
              }
              @case (4) {
                <button disabled class="action-btn-lg primary review">
                  <span class="text">In review</span>
                  <span class="icon"><ods-icon variant="more" aria-hidden="true"></ods-icon></span>
                </button>
              }
              @case (5) {
                <button
                  (click)="addInfo(question)"
                  class="action-btn-lg additional-info"
                  [attr.aria-label]="question.title + ' Additional Info'">
                  <span class="text">Additional Info</span>
                  <span class="icon"><i aria-hidden="true"></i></span>
                </button>
              }
            }
          </div>
          @if ((question['documentId'] || question['cloudDocumentUri']) && question.statusId === 4) {
            <div (click)="showDownload(question)" class="flu-shot__download">
              <ods-icon variant="document" aria-hidden="true"></ods-icon>
            </div>
          }
        </article>
      }
    </div>
  }
</div>

@if (displayLearnMore) {
  <app-show-more
    [title]="selectedInfo?.detailsTitle"
    [description]="selectedInfo?.detailsDescription"
    [imgUrl]="selectedInfo?.imageUrl"
    [imgHeight]="imgHeight"
    (closeEvent)="closeLearnMore()"></app-show-more>
}
